var GenericView = require('views/generic.view.ts');
var _ = require("underscore");
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/financial.template.html');

var TheView = GenericView.extend({
    el: '#financial',
    tagName: '',
	template: Handlebars.compile(Template),
	fields: [],
	initialize: function (options) {
        this.render();
        GenericView.prototype.storeView(this, "financial");
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template);
    },
    events: {
        "input .to-validation input": "validateIt",
        "input .slider": "fillWithValue",
        "input .slider-value": "changeSliderValue",
        "click #collapseDescription": "collapseDescription"
    },
    validateIt: _.debounce(
        function(event)
        {
            var element = $(event.currentTarget);
            this.validateSingleField(element);
        },
    300),
    fillWithValue: function(e) {
        var slider = e.currentTarget;
        var input = $(slider).parent().parent().find('.slider-value');
        input.val(slider.value);
    },
    changeSliderValue: function(e) {
        var input = e.currentTarget;
        var slider = $(input).parent().parent().find("input[type='range']");
        slider.val(input.value);
    },
    collapseDescription: function(event) {
        var btn = event.currentTarget;
        GenericView.prototype.collapseDescription(btn);
    },
    getAllData: function() {
        var data = {
            pv_system_cost: this.convertToFloat("#pv_system_cost"),
            bat_system_cost: this.convertToFloat("#bat_system_cost"),
            bat_cost_decr: this.convertToFloat("#bss_decrease_cost"),
            oam_cost: this.convertToInt("#oam_cost"),
            subsd: this.convertToInt("#subsd"),
            ir: this.convertToFloat("#ir"),
            infr: this.convertToFloat("#infr"),
            e_infr: this.convertToFloat("#e_infr")
        };

        return data;
    }
});

module.exports= TheView;